// import React, { Component } from 'react';
// import {
//   Dropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
// } from 'reactstrap';

// //i18n
// import { withNamespaces } from 'react-i18next';

// // users
// import avatar2 from '../../../assets/images/users/avatar-2.jpg';
// import logodark from '../../../assets/images/logo-dark__.png';
// import { withRouter } from 'react-router-dom';

// class ProfileMenu extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       menu: false,
//     };
//     this.toggle = this.toggle.bind(this);
//   }

//   toggle() {
//     this.setState((prevState) => ({
//       menu: !prevState.menu,
//     }));
//   }

//   render() {
//     let username = 'Admin';
//     if (localStorage.getItem('authUser')) {
//       const obj = JSON.parse(localStorage.getItem('authUser'));
//       // const uNm = obj.email.split('@')[0];
//       username = `${obj.data.user.firstName} ${obj.data.user.lastName}`;
//     }

//     return (
//       <React.Fragment>
//         <Dropdown
//           isOpen={this.state.menu}
//           toggle={this.toggle}
//           className='d-inline-block user-dropdown'
//         >
//           <DropdownToggle
//             tag='button'
//             className='btn header-item waves-effect'
//             id='page-header-user-dropdown'
//           >

//             <img
//               className='rounded-circle header-profile-user mr-1'
//               src={logodark}
//               alt='Header Avatar'
//             />
//             <span className='d-none d-xl-inline-block ml-1 text-transform'>
//               {username}
//             </span>
//             <i className='mdi mdi-chevron-down d-none ml-1 d-xl-inline-block'></i>
//           </DropdownToggle>
//           <DropdownMenu right>
//             {/* <DropdownItem href="#"><i className="ri-user-line align-middle mr-1"></i> {this.props.t('Profile')}</DropdownItem>
//                                 <DropdownItem href="#"><i className="ri-wallet-2-line align-middle mr-1"></i> {this.props.t('My Wallet')}</DropdownItem>
//                                 <DropdownItem className="d-block" href="#"><span className="badge badge-success float-right mt-1">11</span><i className="ri-settings-2-line align-middle mr-1"></i> {this.props.t('Settings')}</DropdownItem>
//                                 <DropdownItem href="#"><i className="ri-lock-unlock-line align-middle mr-1"></i> {this.props.t('Lock screen')}</DropdownItem>
//                                 <DropdownItem divider /> */}
//             <DropdownItem
//               className='text-danger'
//               onClick={() => {
//                 localStorage.removeItem('authUser');
//                 localStorage.removeItem('loanAuth');
//                 localStorage.removeItem('bankAdmin');
//                 this.props.history.push('/login');
//               }}
//             >
//               <i className='ri-shut-down-line align-middle mr-1 text-danger'></i>{' '}
//               {this.props.t('Logout')}
//             </DropdownItem>
//           </DropdownMenu>
//         </Dropdown>
//       </React.Fragment>
//     );
//   }
// }

// export default withNamespaces()(withRouter(ProfileMenu));

// BY ATIQUE ----------------------------------------------------------------------

// import React, { Component } from 'react';
// import {
//   Dropdown,
//   DropdownToggle,
//   DropdownMenu,
//   DropdownItem,
// } from 'reactstrap';

// // FontAwesome icons
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { faBell } from '@fortawesome/free-solid-svg-icons';

// // i18n
// import { withNamespaces } from 'react-i18next';

// // users
// import logodark from '../../../assets/images/logo-dark__.png';
// import { withRouter } from 'react-router-dom';

// class ProfileMenu extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       menu: false,
//     };
//     this.toggle = this.toggle.bind(this);
//   }

//   toggle() {
//     this.setState((prevState) => ({
//       menu: !prevState.menu,
//     }));
//   }

//   render() {
//     let username = 'Admin';
//     if (localStorage.getItem('authUser')) {
//       const obj = JSON.parse(localStorage.getItem('authUser'));
//       username = `${obj.data.user.firstName} ${obj.data.user.lastName}`;
//     }

//     return (
//       <React.Fragment>
//         <Dropdown
//           isOpen={this.state.menu}
//           toggle={this.toggle}
//           className='d-inline-block user-dropdown'
//         >
//         <FontAwesomeIcon icon={faBell} className='mr-1' size='lg' />

//           <DropdownToggle
//             tag='button'
//             className='btn header-item waves-effect'
//             id='page-header-user-dropdown'
//           >
//             <img
//               className='rounded-circle header-profile-user ml-1'
//               src={logodark}
//               alt='Header Avatar'
//             />
//             <span className='d-none d-xl-inline-block ml-1 text-transform'>
//               {username}
//             </span>
//             <i className='mdi mdi-chevron-down d-none ml-1 d-xl-inline-block'></i>
//           </DropdownToggle>
//           <DropdownMenu right>
//             <DropdownItem
//               className='text-danger'
//               onClick={() => {
//                 localStorage.removeItem('authUser');
//                 localStorage.removeItem('loanAuth');
//                 localStorage.removeItem('bankAdmin');
//                 this.props.history.push('/login');
//               }}
//             >
//               <i className='ri-shut-down-line align-middle mr-1 text-danger'></i>{' '}
//               {this.props.t('Logout')}
//             </DropdownItem>
//           </DropdownMenu>
//         </Dropdown>
//       </React.Fragment>
//     );
//   }
// }

// export default withNamespaces()(withRouter(ProfileMenu));

import React, { useEffect, useState } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";

// FontAwesome icons
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faBell } from "@fortawesome/free-solid-svg-icons";

// i18n
import { withNamespaces } from "react-i18next";
import logodark from "../../../assets/images/logo-dark__.png";
import { withRouter } from "react-router-dom";
import useGetAuthed from "../../../helpers/hooks/useGetAuthed";
import {
  Link,
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom.min";
// import { ClipLoader } from "react-spinners";
import usePutAuthed from "../../../helpers/hooks/usePutAuthed";
// import {useNavigate} from "react-router-dom";

const ProfileMenu = ({ t, history }) => {
  const [userDropdownOpen, setUserDropdownOpen] = useState(false);
  const [notificationDropdownOpen, setNotificationDropdownOpen] =
    useState(false);
  // const [data, setData] = useState(null);
  // const [error, setError] = useState(null);
  // const [loading, setLoading] = useState(true);

  // const [notif, setNotif] = useState([]);
  // const [count, setCount] = useState([]);
  // const [hit, setHit] = useState('');
  // const nav = useNavigate();

  // const [authData, errorAuth, loadingAuth, callAuth] = useGetAuthed(
  //   "get_notifications",
  //   true,
  //   "loan"
  // );

  // useEffect(() => {
  //   if (!loadingAuth && authData) {
  //     const formattedNotifications = authData.notifications.map(
  //       (notification) => {
  //         const date = new Date(notification.createdAt);
  //         const readid = notification._id;
  //         const formattedDate = `${date.getDate()} - ${
  //           date.getMonth() + 1
  //         } - ${date.getFullYear()}`;
  //         return {
  //           ...notification,
  //           formattedCreatedAt: formattedDate,
  //         };
  //       }
  //     );

  //     setNotif(formattedNotifications);
  //     setCount(formattedNotifications.length);
  //     setLoading(false);
  //     console.log(formattedNotifications);
  //   } else if (!loadingAuth && errorAuth) {
  //     setError(errorAuth);
  //     setLoading(false);
  //   }
  // }, [authData, errorAuth, loadingAuth]);

  // const ids = [];
  // notif.map(notification => {
  //   ids.push(notification._id);
  // });
  // console.log(ids);

  // const [call, getdata, geterror, getloading] = usePutAuthed(`read_notification/${ids}`, 'loan');

  // function markAsRead(){
  //   call(null);
  // }

  const toggleUserDropdown = () => {
    setUserDropdownOpen((prevState) => !prevState);
  };

  const toggleNotificationDropdown = () => {
    setNotificationDropdownOpen((prevState) => !prevState);
    // setCount([]);
  };

  let username = "Admin";
  if (localStorage.getItem("authUser")) {
    const obj = JSON.parse(localStorage.getItem("authUser"));
    username = `${obj.data.user.firstName} ${obj.data.user.lastName}`;
  }

  return (
    <React.Fragment>
      <Dropdown
        isOpen={notificationDropdownOpen}
        toggle={toggleNotificationDropdown}
        className="d-inline-block notification-dropdown"
        style={{ display: "flex", flexDirection: "column" }}
      >
        {/* <DropdownToggle
          tag="button"
          className="btn header-item waves-effect"
          id="page-header-notification-dropdown"
        >
          {count && count > 0 && (
            <h10
              style={{
                position: "absolute",
                backgroundColor: "red",
                color: "black",
                marginLeft: "20px",
                fontSize: "15px",
                height: "20px",
                padding: "1px",
              }}
            >
              +{count}
            </h10>
          )}

          <FontAwesomeIcon icon={faBell} size="2x" />
        </DropdownToggle> */}
        {/* <DropdownMenu
          right
          style={{
            overflowY: "scroll",
            position: "relative",
            height: "auto",
          }}
        >
          {loading ? (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <ClipLoader
                color={"#000000"}
                loading={loading}
                size={40}
                aria-label="Loading Spinner"
                speedMultiplier={1}
              />
            </div>
          ) : (
            notif.map((notification, index) => (
              <a
                href={`/loan-detail/${notification._id}/${notification.loan_id}`}
              >
                <DropdownItem
                  key={index}
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    flexWrap: "wrap",
                    width: "500px",
                    overflowX: "hidden",
                    maxHeight: "200px",
                    border: "1px solid #ddd",
                    padding: "10px",
                    backgroundColor: notification.read ? "#f1f5f7" : "#242a3a",
                    fontFamily: "Times New Roman",
                    color: notification.read ? "black" : "#a7a9b0",
                  }}
                  
                >
                  <span style={{ fontSize: "20px", fontWeight: "bold" }}>
                    {notification.title}
                  </span>
                  <span style={{ fontSize: "17px" }}>
                    {notification.message}
                  </span>
                  <span style={{ fontSize: "17px" }}>
                    {" "}
                    Created At: {notification.formattedCreatedAt}
                  </span>
                </DropdownItem>
              </a>
            ))
          )}
        </DropdownMenu> */}
      </Dropdown>
      <Dropdown
        isOpen={userDropdownOpen}
        toggle={toggleUserDropdown}
        className="d-inline-block user-dropdown"
      >
        <DropdownToggle
          tag="button"
          className="btn header-item waves-effect"
          id="page-header-user-dropdown"
        >
          <img
            className="rounded-circle header-profile-user ml-1"
            src={logodark}
            alt="Header Avatar"
          />
          <span className="d-none d-xl-inline-block ml-1 text-transform">
            {username}
          </span>
          <i className="mdi mdi-chevron-down d-none ml-1 d-xl-inline-block"></i>
        </DropdownToggle>
        <DropdownMenu right>
        <DropdownItem
            className="text-danger"
            onClick={() => {
              history.push("/reset-password");
            }}
          >
            {/* <i className="ri-shut-down-line align-middle mr-1 text-danger"></i>{" "} */}
            <i className="ri-key-line align-middle mr-1 text-primary text-danger"></i>{" "}

            {t("Change Password")}
          </DropdownItem>
          <DropdownItem
            className="text-danger"
            onClick={() => {
              localStorage.removeItem("authUser");
              localStorage.removeItem("loanAuth");
              localStorage.removeItem("bankAdmin");
              history.push("/login");
            }}
          >
            <i className="ri-shut-down-line align-middle mr-1 text-danger"></i>{" "}
            {t("Logout")}
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </React.Fragment>
  );
};

export default withNamespaces()(withRouter(ProfileMenu));



